import React from "react";

import brandLogo from "../assets/img/brand/logo.png";
import "../styles/golocal-brand.css";

export default function GoLocalBrandMark({ className = "" }) {
  return (
    <div className={`golocal-brand ${className}`.trim()}>
      <div className="golocal-brand-inner">
        <div className="golocal-logo-wrap">
          <img
            src={brandLogo}
            alt="GoLocal"
            className="golocal-logo"
            width={40}
            height={40}
            decoding="async"
          />
          <div className="golocal-logo-glow" aria-hidden />
        </div>
        <div className="golocal-wordmark-stack">
          <span className="golocal-wordmark">GoLocal</span>
          <span className="golocal-wordmark-tagline">Admin tools</span>
        </div>
      </div>
    </div>
  );
}
